module.exports = __webpack_public_path__ + "046c86852c4dcbb727ff34691fcef495.svg";